/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { PurchaseOrderHeadersService } from '@control-tower/platform-orders';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFOrdersEntities,
} from '@pf/shared-common';
import { PurchaseOrderHeaderStore } from './purchase-order-header.store';
import {
    PurchaseOrderHeaderCreate,
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderSearchParams,
} from '../../entities/purchase-order-header.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class PurchaseOrderHeaderDataService extends AbstractDataService<
    PurchaseOrderHeaderRead,
    PurchaseOrderHeaderCreate
> {
    protected EntityName = PFOrdersEntities.PurchaseOrderHeader;
    constructor(
        private service: PurchaseOrderHeadersService,
        store: PurchaseOrderHeaderStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: PurchaseOrderHeaderCreate
    ): Observable<PurchaseOrderHeaderRead> {
        return this.service.purchaseOrderHeaderCreate({
            purchaseOrderHeaderViewModelCreateBody: body,
        }) as Observable<PurchaseOrderHeaderRead>;
    }
    protected deleteObs$(id: string): Observable<PurchaseOrderHeaderRead> {
        return this.service.purchaseOrderHeaderDelete({
            id,
        }) as Observable<PurchaseOrderHeaderRead>;
    }
    protected undoDeleteObs$(id: string): Observable<PurchaseOrderHeaderRead> {
        return this.service.purchaseOrderHeaderUndoDelete({
            id,
        }) as Observable<PurchaseOrderHeaderRead>;
    }
    protected getObs$(id: string): Observable<PurchaseOrderHeaderRead> {
        return this.service.purchaseOrderHeaderReadById({
            id,
        }) as Observable<PurchaseOrderHeaderRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<PurchaseOrderHeaderRead> {
        return this.service.purchaseOrderHeaderUpdatePatch({
            id,
            operation: operations,
        }) as Observable<PurchaseOrderHeaderRead>;
    }
    protected searchObs$(
        searchParams: PurchaseOrderHeaderSearchParams
    ): Observable<IPagedResult<PurchaseOrderHeaderRead>> {
        return this.service.purchaseOrderHeaderSearch(
            searchParams
        ) as Observable<IPagedResult<PurchaseOrderHeaderRead>>;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<
        IPagedResult<EntityChangeTrackingDto<PurchaseOrderHeaderRead>>
    > {
        return this.service.purchaseOrderHeaderGetChanges(
            searchParams
        ) as Observable<
            IPagedResult<EntityChangeTrackingDto<PurchaseOrderHeaderRead>>
        >;
    }
}
